import { IRootState } from '@/resources/interfaces';

export const getAccount = (state: IRootState) => state.authReducer.account;
export const getTokens = (state: IRootState) => state.authReducer.tokens;
export const getQr = (state: IRootState) => state.authReducer.qr;
export const getTFAEnabled = (state: IRootState) =>
  state.authReducer.tfaEnabled;
